export default __webpack_public_path__ + "static/media/fuddle1.86d4459c.png";